define('modules/editor/views/elements/social_google',['require','exports','module','backbone'],function(require, exports, module) {
  "use strict";
  var Backbone = require("backbone");

  module.exports = Backbone.View.extend({
    className: "g-plusone",
    attributes: {
      "data-size": "medium"
    },
    render: function() {
      module.exports.__super__.render.apply(this, arguments);
      if (!this.model.get("counter")) {
        this.$el.attr("data-annotation", "none");
      } else {
        this.$el.removeAttr("data-annotation");
      }
      return this;
    }
  });
});

